/* eslint-disable @typescript-eslint/no-explicit-any */
// pls fix me
import { UserPreferenceName } from '@modules/userPreferences';
import { useUserPreference } from '@modules/userPreferences/hooks';
import { Theme } from '@modules/common/types/general';
import { FormControl, MenuItem, Select } from '@mui/material';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { useMemo } from 'react';

type Props = {
  name?: string;
  disabled?: boolean;
  options?: any[];
  value?: any;
  onChange?: (value: any) => void;
  ellipsis?: boolean;
  placeholder?: string;
};

export function SelectInput({
  disabled,
  name,
  options,
  value,
  onChange,
  ellipsis = false,
  placeholder,
}: Props) {
  const theme = useUserPreference(UserPreferenceName.GENERAL_THEME);
  const mode = useAppStore((state) => state.mode);

  const renderValue = (selected) => {
    if (placeholder && (selected === '' || selected === null || selected === undefined)) {
      return <span style={{ opacity: 0.7 }}>{placeholder}</span>;
    }

    const match = options?.find((o) => o?.value === selected);
    return match?.label ?? selected;
  };

  const isDisabled = useMemo(() => disabled === true || mode !== 'EDITABLE', [disabled, mode]);

  return (
    <FormControl fullWidth sx={{ minWidth: 0 }}>
      <Select
        name={name}
        disabled={isDisabled}
        disableUnderline
        variant='standard'
        value={value}
        displayEmpty={!!placeholder}
        renderValue={renderValue}
        onChange={(e) => onChange?.(e.target.value)}
        sx={{
          width: '100%',
          minWidth: 0,
        }}
        MenuProps={{
          classes: { paper: theme === Theme.DARK ? 'dark' : '' },
        }}
      >
        {options?.map(({ label, value: optionValue, disabled: optionDisabled }) => (
          <MenuItem
            key={`${label}-${optionValue}`}
            value={optionValue}
            disabled={optionDisabled}
            sx={{
              ...(ellipsis && {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }),
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
